<script lang="ts">
	interface Props {
		value: any
		/**
		 * the key is the display name and the value is the value of the option
		 */
		options: {
			[index: string]: any
		}
		small?: boolean
		id?: string
	}

	let { value = $bindable(), options, small = false, id = undefined }: Props = $props()

	let activeOption: string = $state(Object.keys(options)[0])
	let activeIndex: number = $state(0)

	function updateActiveOption(key: string, val: any, optionElem: EventTarget) {
		activeIndex = Object.keys(options).findIndex((val) => val === key)
		activeOption = key
		value = val
	}
</script>

<div class="Switch {small ? 'small' : ''}" id={id ? id : ""}>
	{#each Object.entries(options) as [name, opt]}
		<button
			type="button"
			class="SwitchOpt {activeOption === name ? 'active' : ''}"
			onclick={(e) => updateActiveOption(name, opt, e.target)}
			tabindex={activeOption === name ? -1 : 0}
		>
			{name}
		</button>
	{/each}
	<div class="active-indicator" style="transform: translateX({activeIndex}00%)"></div>
</div>

<style>
	.Switch {
		box-shadow: var(--shadow-medium);
		width: fit-content;
		height: 2.5rem;
		position: relative;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		background-color: var(--color-accent);
		z-index: 5;
		font-size: var(--text-small);
		border-radius: var(--br);
		margin: 1rem;

		--button-width: 8rem;
	}

	.Switch.small {
		margin: 0;
		height: 2rem;
		--button-width: 4rem;
	}

	button.SwitchOpt {
		text-align: center;
		z-index: 6;
		color: var(--color-text-light);
		background-color: unset;
		box-shadow: unset;
		transform: unset;
		width: var(--button-width);
		padding: 0.5rem 0;
		transition:
			color var(--transition-duration),
			background-color var(--transition-duration);
	}

	button.SwitchOpt:not(.active):hover,
	button.SwitchOpt:not(.active):focus-visible {
		background-color: var(--color-main-transparent);
	}

	button.SwitchOpt.active {
		color: var(--color-text);
		cursor: initial;
	}

	.Switch.small button.SwitchOpt {
		padding: unset;
		height: 100%;
	}

	.active-indicator {
		box-shadow: var(--shadow-large);
		border-radius: var(--br);
		z-index: -1;
		width: var(--button-width);
		position: absolute;
		top: 0;
		left: 0;
		height: 100%;
		background-color: var(--color-main);
		transition: transform var(--transition-duration);
	}
</style>
